import EventListComponent from './event-list.component';

export {
  EventListComponent
}



// WEBPACK FOOTER //
// src/events/index.js